<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-detached">
			<div class="content-body">
				<app-search-bar [config]="configLocal.barraBusqueda" [criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal" [registroActivacion]="true" [useAccordionMode]="true" [useInlineDeactivatedCheckbox]="true" [useInlineSearchButton]="true" (busqueda)="searchElementsByFilter($event)"></app-search-bar>
				<div class="row">
					<div class="col-12">
						<div class="card card-custom">
							<div class="card-header">
								<h4 class="card-title">Mantenedor Cesionario</h4>
							</div>
							<div class="card-head">
								<div class="heading-elements mt-0">
									<button class="btn btn-warning float-right mr-5 mt-5 btn-export buttonMantenedor" (click)="exportToExcel()" data-gtm-id="exportar" data-gtm-group="cesionarios" ngbTooltip="Utilice el filtro de búsqueda para acotar el rango a exportar" *ngIf="permissions.getPermission('30-15-10').asignado">
										<i class="flaticon-download-1"></i>
										Exportar
									</button>
									<button class="btn btn-success float-right mr-5 mt-5 buttonMantenedor" (click)="openAddCesionarioModal(addCesionarioModal)" data-gtm-id="crear" data-gtm-group="cesionarios" *ngIf="permissions.getPermission('30-15-12').asignado">
										<i class="flaticon-add-circular-button"></i>
										Agregar Cesionario
									</button>
								</div>
							</div>

							<div class="card-content">
								<div class="card-body">
									<ngx-datatable
										#table
										class="material mobile-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="50"
										[rowHeight]="70"
										fxFlex="auto"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										(sort)="utilities.onSortTable(table, page)"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
										[externalSorting]="false"
										[sortType]="SortType.multi"
									>
										<ngx-datatable-column name="rutFormateado" [flexGrow]="2" [sortable]="true" [resizeable]="false" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Rut</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.rutFormateado }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="razonSocial" [flexGrow]="4" [sortable]="true" [resizeable]="false" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Razon Social</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.razonSocial }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="direccion" [flexGrow]="2" [sortable]="false" [resizeable]="false" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Dirección</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.direccion }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="telefono" [flexGrow]="2" [sortable]="false" [resizeable]="false" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Telefono</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.fono }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="Acciones" [flexGrow]="1.5" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<a class="primary edit mr-1 mrless" ngbTooltip="Editar Cesionario" id="mantenedor-cesionario.component_Editar_Cesionario" (click)="openEditCesionarioModal(editCesionarioModal, row)" *ngIf="permissions.getPermission('30-15-14').asignado">
													<div class="icon-circle bg-info text-center align-middle pt-info-button">
														<fa-icon icon="pencil-alt" class="fa-lg text-white"></fa-icon>
													</div>
												</a>

												<a class="primary edit mr-1 mrless" ngbTooltip="Detalle Cesionario" id="mantenedor-cesionario.component_Detalle_Cesionario" (click)="openShowCesionarioModal(detailCesionarioModal, row)" *ngIf="permissions.getPermission('30-15-16').asignado">
													<div class="icon-circle bg-warning text-center align-middle pt-info-button">
														<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>

												<a
													*ngIf="permissions.getPermission('30-15-18').asignado && row.activo"
													class="primary edit mr-1 mrless"
													ngbTooltip="Desactivar Cesionario"
													[swal]="{
														title: 'Confirmación',
														text: '¿Está seguro de desactivar este Cesionario?',
														confirmButtonText: 'Desactivar',
														cancelButtonText: 'Cancelar',
														showCancelButton: true,
														confirmButtonColor: '#F64E60'
													}"
													(confirm)="deactivateCesionario(row)"
												>
													<div class="icon-circle bg-danger text-center align-middle pt-info-button">
														<fa-icon icon="times-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a
													*ngIf="permissions.getPermission('30-15-18').asignado && !row.activo"
													class="primary edit mr-1 mrless"
													ngbTooltip="Activar Cesionario"
													[swal]="{
														title: 'Confirmación',
														text: '¿Está seguro de activar este Cesionario?',
														confirmButtonText: 'Activar',
														cancelButtonText: 'Cancelar',
														showCancelButton: true,
														confirmButtonColor: '#F64E60'
													}"
													(confirm)="activateCesionario(row)"
												>
													<div class="icon-circle bg-success text-center align-middle pt-info-button">
														<fa-icon icon="check-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="col-auto">Elementos por página</div>
												<div class="mr-5">
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-5 col-auto divisor-footer">
													<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos totales</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="table.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>

									<!-- seccion tabla mobile-->
									<ngx-datatable
										#tableMobile
										*ngIf="componentStarted"
										class="material desktop-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="70"
										[rowHeight]="70"
										fxFlex="auto"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										[scrollbarH]="true"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
									>
										<!-- Row Detail Template -->
										<ngx-datatable-row-detail [rowHeight]="70" #myDetailRow>
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
												<div class="text-wrap">Rut: {{ row.rutFormateado }} , Dirección: {{ row.direccion }} , Telefono: {{ row.fono }}</div>
											</ng-template>
										</ngx-datatable-row-detail>
										<ngx-datatable-column [width]="30" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
												<a [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="Expand/Collapse Row" (click)="toggleExpandRow(row)" class="desktop-hidden"> </a>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="Razón Social" [flexGrow]="5.5" [sortable]="false" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Razón Social</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.razonSocial }}</span>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="Acciones" [flexGrow]="3" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<div class="action-container">
													<div class="main-action-button" (click)="toggleActions(row)" *ngIf="!row.showActions">
														<fa-icon [icon]="row.showActions ? 'minus' : 'list'"></fa-icon>
													</div>

													<div class="action-buttons action-buttons-client" [ngClass]="{ show: row.showActions }">
														<a class="primary edit mr-1 mrless" ngbTooltip="Editar Cesionario" id="mantenedor-cesionario.component_Editar_Cesionario" (click)="openEditCesionarioModal(editCesionarioModal, row)" *ngIf="permissions.getPermission('30-15-14').asignado">
															<div class="icon-circle bg-info text-center align-middle pt-info-button">
																<fa-icon icon="pencil-alt" class="fa-lg text-white"></fa-icon>
															</div>
														</a>

														<a class="primary edit mr-1 mrless" ngbTooltip="Detalle Cesionario" id="mantenedor-cesionario.component_Detalle_Cesionario" (click)="openShowCesionarioModal(detailCesionarioModal, row)" *ngIf="permissions.getPermission('30-15-16').asignado">
															<div class="icon-circle bg-warning text-center align-middle pt-info-button">
																<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
															</div>
														</a>

														<a
															*ngIf="permissions.getPermission('30-15-18').asignado && row.activo"
															class="primary edit mr-1 mrless"
															ngbTooltip="Desactivar Cesionario"
															[swal]="{
																title: 'Confirmación',
																text: '¿Está seguro de desactivar este Cesionario?',
																confirmButtonText: 'Desactivar',
																cancelButtonText: 'Cancelar',
																showCancelButton: true,
																confirmButtonColor: '#F64E60'
															}"
															(confirm)="deactivateCesionario(row)"
														>
															<div class="icon-circle bg-danger text-center align-middle pt-info-button">
																<fa-icon icon="times-circle" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a
															*ngIf="permissions.getPermission('30-15-18').asignado && !row.activo"
															class="primary edit mr-1 mrless"
															ngbTooltip="Activar Cesionario"
															[swal]="{
																title: 'Confirmación',
																text: '¿Está seguro de activar este Cesionario?',
																confirmButtonText: 'Activar',
																cancelButtonText: 'Cancelar',
																showCancelButton: true,
																confirmButtonColor: '#F64E60'
															}"
															(confirm)="activateCesionario(row)"
														>
															<div class="icon-circle bg-success text-center align-middle pt-info-button">
																<fa-icon icon="check-circle" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="row" style="width: 100%">
													<div class="col-12 mb-2 ml-3 text-center mt-2">
														<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableMobile.onFooterPage($event)"> </datatable-pager>
													</div>
													<div class="col-12 d-flex justify-content-center">
														<span class="mr-2 mt-3">Elementos por página</span>

														<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="body">
															<option *ngFor="let option of page.pageSizes" [value]="option"></option>
														</ng-select>
														<span class="ml-4 mt-3"> Página {{ curPage }} de {{ getTotalPages(rowCount, pageSize) }} </span>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
									<!-- fin seccion tabla mobile-->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<ng-template #addCesionarioModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Agregar Cesionario</div>
				<div class="modal-wizard-desc">Ingrese datos del nuevo cesionario</div>
			</div>
		</div>
		<div class="modal-body">
			<app-cesionario-entry [detailMode]="false" (sendCloseRequestEmitter)="closeAddCesionarioModal()" (sendCesionarioRequest)="sendNewCesionario($event)"></app-cesionario-entry>
		</div>
	</div>
</ng-template>
<ng-template #editCesionarioModal>
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Editar Cesionario</div>
				<div class="modal-wizard-desc">Modifica los datos ddel cesionario</div>
			</div>
		</div>
		<div class="modal-body">
			<app-cesionario-entry [detailMode]="false" [editMode]="true" [cesionarioToEdit]="selectedCesionario" (sendCloseRequestEmitter)="closeEditCesionarioModal()" (sendCesionarioRequest)="editCesionarioRequest($event)"></app-cesionario-entry>
		</div>
	</div>
</ng-template>
<ng-template #detailCesionarioModal>
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Detalle Cesionario</div>
				<div class="modal-wizard-desc">Se muestran los detalles del Cesionario</div>
			</div>
		</div>
		<div class="modal-body">
			<app-cesionario-entry [detailMode]="true" [editMode]="true" [cesionarioToEdit]="selectedCesionario" (sendCloseRequestEmitter)="closeShowCesionarioModal()"></app-cesionario-entry>
		</div>
	</div>
</ng-template>
